import React from 'react'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import Toolbar from './toolbar/'
import Context from './context/'

import Title from '../ui/title'
import Content from '../ui/content'

import Back from '../ui/back'

import UsersList from './users'
import JobsList from './jobs'
import DevicesList from './devices'

class Organisation extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      usersView: true,
      devicesView: false,
      jobsView: false,
      contextMenu: false,
      defaultColumns: [],
      filterable: false,
      users: null
    }
    this.toggle = this.toggle.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
  }

  componentWillMount() {
    this._users()
  }

  setColumns(type) {

    const { translate, classes } = this.props
    const { defaultColumns } = this.state

    let data = this.state[type]

    let columns = []
    data.columns.forEach((column, index) => {
      columns.push({
        id: column.field,
        Header: translate(column.field),
        accessor: d => d[column.field],
        show: defaultColumns.includes(column.field),
        display: column.display
      })
    })

    // Todo: when we add in other type need to add appropriate button here
    columns.push({
      id: 'detail',
      Header: "Action",
      accessor: d => d.UserName,
      show: true,
      Cell: o => (
        <Button raised className={classes.button} onClick={() => this.impersonate(o.row)}>{translate("general_impersonate")}</Button>
      ),
      filterable: false,
      sortable: false
    })

    this.setState({
      columns: columns
    })

  }

  _users() {
    this.clearView()
    this.setState({ usersView: true })
    this.setState({ defaultColumns: ['firstname', 'lastname'] })
  }

  users = (table) => {
    const { selectedCustomer, pager } = this.props

    // if (table) {
    this.props.getUsers(table)
    // .then(() => {
    //   this.setColumns('users')
    // })
    // }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.users && nextProps.users.data) {
      this.setState({
        users: { ...nextProps.users }
      }, () => {
        this.setColumns('users')
      })
    }
  }

  jobs() {
    // const { selectedCustomer, pager } = this.props
    this.clearView()
    this.setState({ jobsView: true })
    this.setState({ defaultColumns: ['name'] })
    // this.props.getJobs(pager, selectedCustomer.id)
    // this.setColumns('jobs')
  }

  devices() {
    // const { selectedCustomer, pager } = this.props
    this.clearView()
    this.setState({ devicesView: true })
    this.setState({ defaultColumns: ['name'] })
    // this.props.getDevices(pager, selectedCustomer.id)
    // this.setColumns('devices')

  }

  clearView() {
    this.setState({
      usersView: false,
      devicesView: false,
      jobsView: false
    })
  }

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu,
    })
  }

  toggleColumns(column) {

    let columns = [...this.state.columns]
    let defaultColumns = [...this.state.defaultColumns]

    columns.forEach((c) => {
      if (c.id === column.id) {
        c.show = column.show
      }
    })
    if (column.show) {
      defaultColumns.push(column.id)
    } else {
      if (defaultColumns.indexOf(column.id) > -1) {
        defaultColumns.splice(defaultColumns.indexOf(column.id), 1);
      }
    }

    this.setState({
      columns,
      defaultColumns
    })

  }

  toggleFilters = () => {
    let columns = [...this.state.columns]
    let { filterable } = this.state
    columns.forEach((c) => {
      c.filterable = !filterable
    })
    this.setState({
      columns: columns,
      filterable: !filterable
    })
  }

  render() {

    const {
      translate,
      classes,
      selectedCustomer,
      users,
      jobs,
      devices,
      pager,
      impersonationRequest,
      getUsers
    } = this.props

    const {
      usersView,
      jobsView,
      devicesView,
      defaultColumns,
      filterable
    } = this.state

    let $context = ((users || jobs || devices) && (
      <Context
        toggleColumns={this.toggleColumns}
        data={users.data}
        columns={this.state.columns || []}
        translate={translate}
      />
    ))

    if (users === null) {
      return <div className={classes.loading}>{translate("result_loading")}</div>
    }

    return (
      <div style={{marginTop: "135px"}}>
        <Title
          logo={selectedCustomer.logo}
          title={selectedCustomer.name}
          back={<Back title={translate("general_organisations")} link={"/organisations"} />}
          toolbar={<Toolbar
            users={() => this.users()}
            jobs={() => this.jobs()}
            devices={() => this.devices()}
            toggle={() => this.toggle()}
            toggleFilters={this.toggleFilters}
            translate={translate}
          />}
        />
        <Content ctx={$context} open={this.state.contextMenu} toggle={() => this.toggle()} translate={translate}>
          {usersView && users && defaultColumns && (
            <UsersList
              users={users}
              pager={pager}
              translate={translate}
              defaultColumns={defaultColumns}
              impersonationRequest={impersonationRequest}
              filterable={filterable}
              fetch={this.users}
            />
          )}
          {jobsView && (<JobsList />)}
          {devicesView && (<DevicesList />)}
        </Content>
      </div >
    )
  }

  componentDidMount() {
    this.users()
  }
}

export default withStyles(styles)(Organisation)
